import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/**
 * 事件观察者
 */
var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    _classCallCheck(this, Emitter);

    _defineProperty(this, "eventList", {});

    this.eventList = {};
  }

  _createClass(Emitter, [{
    key: "on",
    value: function on(eventName, callback) {
      this.eventList[eventName] = this.eventList[eventName] || [];
      this.eventList[eventName].push(callback);
      return;
    }
  }, {
    key: "off",
    value: function off(eventName) {
      if (!this.eventList[eventName]) return;
      delete this.eventList[eventName];
    }
  }, {
    key: "emit",
    value: function emit(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (!this.eventList[eventName]) return;
      this.eventList[eventName].forEach(function (eventItem) {
        return eventItem.apply(void 0, args);
      });
    }
  }]);

  return Emitter;
}();

export default function emitter() {
  return new Emitter();
}